export default __webpack_public_path__ + "static/media/xp-spot-b.95da5809.svg";